import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MaintenanceGate from './MaintenanceGate';
import maintenanceApi from './api/appAuthenticatedApi';
import { useLocation } from 'react-router-dom';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Redux/Store';

function Availability() {
const { pathname } = useLocation();
const siteCode = 'app';
return <MaintenanceGate siteCode={siteCode} statusUrl={'/api/app/maintenance-status'} loginPath={'/login'} apiClient={maintenanceApi} pathname={pathname} ><App /></MaintenanceGate>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Availability />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
